import { useMemo, useState } from "react";
import { Button } from "@mui/material";
import axios from "axios";
import Auth, { API_URL } from "../../../../utils/auth";
import "./ZapierConsent.css";

const ZapierConsent = () => {
  const [acknowledged, setAcknowledged] = useState(false);
  const [error, setError] = useState("");

  const permissions = useMemo(
    () => [
      "Read customer and account data needed for automations",
      "Create or update client records from Zapier",
      "Send task and activity updates to ClientBloom",
      "Access integration settings for this workspace",
    ],
    []
  );

  const handleAuthorize = async () => {
    if (!acknowledged) {
      setError("Please confirm the authorization checkbox.");
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const client_id = params.get("client_id");
    const redirect_uri = params.get("redirect_uri");
    const state = params.get("state");
    const scope = params.get("scope");
    const response_type = params.get("response_type");

    if (!client_id || !redirect_uri || !state || !response_type) {
      setError("Missing required authorization parameters.");
      return;
    }

    try {
      const response = await axios.post(
        `${API_URL}/zapier/authorize`,
        {
          consent: acknowledged,
          client_id,
          redirect_uri,
          state,
          scope,
          response_type,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Client": "frontend",
          },
          withCredentials: true,
        }
      );

      const redirectUrl = response.data?.redirectUrl || "";
      if (redirectUrl) {
        if (window.opener) {
          window.opener.location.href = redirectUrl;
          window.close();
        } else {
          window.location.href = redirectUrl;
        }
        return;
      }

      if (window.opener) {
        window.close();
        return;
      }

      setError("Authorization completed, but no redirect URL was provided.");
    } catch (err) {
      setError("Authorization failed. Please try again.");
    }
  };

  return (
    <div className="zapier-consent-page">
      <div className="zapier-consent-card">
        <div className="zapier-consent-header">
          <div className="zapier-consent-logo">
            <img
              src="/cb_logo.png"
              alt="ClientBloom"
              className="zapier-consent-logo-image"
            />
          </div>
          <div>
            <div className="zapier-consent-title">ClientBloom Consent</div>
            <div className="zapier-consent-subtitle">
              Zapier will access your ClientBloom account after you approve
            </div>
          </div>
        </div>

        <div className="zapier-consent-section">
          <div className="zapier-consent-section-title">Requested permissions</div>
          <ul className="zapier-consent-list">
            {permissions.map((item) => (
              <li key={item}>
                <span className="zapier-consent-check">✓</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <label className="zapier-consent-ack">
          <input
            type="checkbox"
            checked={acknowledged}
            onChange={(event) => setAcknowledged(event.target.checked)}
          />
          I understand and allow ClientBloom to access Zapier on my behalf.
        </label>

        {error && <div className="zapier-consent-error">{error}</div>}

        <div className="zapier-consent-actions">
          <Button
            variant="outlined"
            className="zapier-consent-cancel"
            onClick={() => window.history.back()}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="zapier-consent-approve"
            disabled={!acknowledged}
            onClick={handleAuthorize}
          >
            Approve & Connect
          </Button>
        </div>

        <div className="zapier-consent-footer">
          By continuing, you agree to ClientBloom’s Terms and Privacy Policy.
        </div>
      </div>
    </div>
  );
};

export default ZapierConsent;
